import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface PartNumberChangeResponse {
    originalPart: {
        partNumber: string;
        partName: string | null;
        qualifiers: Array<string> | null;
    };
    changedPart: {
        partNumber: string;
        partName: string | null;
        qualifiers: Array<string> | null;
    };
}

const getPartNumberChange = async (sessionId: string, originalPartNumber: string, changedPartNumber: string, vin: string): Promise<PartNumberChangeResponse> => {
    const { data } = await axios.get(`${API_URL}/order/part-number/change`, {
        params: { originalPartNumber, changedPartNumber, vin },
        headers: {
            Authorization: sessionId
        }
    });
    return data;
};

const useGetPartNumberChange = (originalPartNumber: string, changedPartNumber: string, vin: string, isOpen: boolean) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['part-number-change', originalPartNumber, changedPartNumber],
        queryFn: () => getPartNumberChange(
            sessionContext?.sessionId ?? '',
            originalPartNumber,
            changedPartNumber,
            vin
        ),
        enabled: !!originalPartNumber && !!changedPartNumber && !!sessionContext?.sessionId && isOpen,
    });
};

export default useGetPartNumberChange;
